import { useMutation, useQueryClient } from '@tanstack/react-query'
import User from '../../model/User'
import { dataSource } from '../../service/domain/_service.config'
import { optimisticUpdate } from '../util/optimisticUpdate'
import { USER_QUERY_KEY } from './useUser'

export function useSaveUser() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (user: User) => dataSource.saveUser(user),
    ...optimisticUpdate<User | null, User>(queryClient, USER_QUERY_KEY, (_current, user) => user),
  })
}
